{
  "$schema": "./locales.schema.json",
  "defaultLocale": "en",
  "locales": {
    "en": {
      "label": "English",
      "path": "./",
      "languageTag": "en",
      "languageAliases": [],
      "page": {
        "applicationName": "Mattriz",
        "title": "Mattriz — Interactive Transformation Matrix Visualizer",
        "description": "Explore 2D and 3D linear transformations with editable matrices, vectors, and animated coordinate grids.",
        "openGraphSiteName": "Mattriz",
        "openGraphLocale": "en_US"
      },
      "manifest": {
        "path": "manifest.webmanifest",
        "name": "Mattriz",
        "short_name": "Mattriz",
        "description": "Explore 2D and 3D linear transformations with editable matrices, vectors, and animated coordinate grids."
      },
      "messages": {
        "language": "Language",
        "transformationViewport": "Transformation viewport",
        "animatedCoordinateSpace": "Animated coordinate space",
        "viewportPreparing": "Preparing visualization…",
        "viewportUnavailableTitle": "Visualization unavailable",
        "viewportUnavailableDescription": "WebGL could not start. You can still edit the equation and use the controls below.",
        "retryViewport": "Retry visualization",
        "dimension": "Dimension",
        "appControls": "App controls",
        "resetView": "Reset view",
        "resetWorkspace": "Reset workspace",
        "resetWorkspaceTitle": "Reset workspace?",
        "resetWorkspaceDescription": "This clears all matrices, vectors, views, and settings and restores the default workspace.",
        "confirmResetWorkspace": "Reset everything",
        "cancel": "Cancel",
        "share": "Save & Share",
        "sharing": "Sharing…",
        "shareTimedOut": "Sharing timed out",
        "shareRequiresValidWorkspace": "Fix invalid inputs before sharing.",
        "copied": "Saved & copied",
        "shareCopiedTitle": "Workspace saved — link copied",
        "shareCopiedDescription": "Your workspace is saved in this link. Paste it into a message to share it.",
        "shareManualTitle": "Workspace saved — copy the link",
        "shareManualDescription": "Automatic copying was blocked. Select and copy the saved workspace link below.",
        "shareLink": "Saved workspace link",
        "copyFailed": "Copy failed",
        "shareTooLarge": "Link too large",
        "invalidShareTitle": "Invalid shared workspace",
        "invalidShareDescription": "This shared workspace is invalid, unsafe, or uses an unsupported version. The default workspace has been loaded.",
        "about": "About",
        "controls": "Controls",
        "animation": "Animation",
        "animationControls": "Animation controls",
        "applyTransform": "Apply transform",
        "pauseAnimation": "Pause animation",
        "resumeAnimation": "Resume animation",
        "apply": "Apply",
        "pause": "Pause",
        "resume": "Resume",
        "reset": "Reset",
        "resetTransform": "Reset transform",
        "method": "Method",
        "animationMethod": "Animation method",
        "steps": "Step-by-step",
        "composed": "Composed transform",
        "basis": "Basis",
        "grid": "Grid lines",
        "transformationEquation": "Transformation equation",
        "quickReference": "Quick reference",
        "aboutMattriz": "About Mattriz",
        "close": "Close",
        "intro": "Build matrices and vectors, then watch each linear transformation unfold in 2D or 3D.",
        "mattrizControls": "Mattriz controls",
        "control": "Control",
        "whatItDoes": "What it does",
        "switchDimensions": "Switch the workspace between ℝ² and ℝ³.",
        "restoreCamera": "Restore the camera for the current dimension.",
        "applyDescription": "Animate the matrices applied to your vectors and grid.",
        "pauseDescription": "Pause an animation or continue from the same point.",
        "resetDescription": "Return the transformation to the identity matrix.",
        "methodDescription": "Animate matrices one at a time or as one composed transform.",
        "basisDescription": "Show or hide the transformed basis vectors.",
        "gridDescription": "Show or hide the transformed coordinate grid lines.",
        "addDescription": "Add an editable matrix or vector to the equation.",
        "expressions": "Expressions",
        "expressionsDescription": "Entries accept mathematical expressions that evaluate to a real number between -100 and 100.",
        "inputErrors": "Input error details",
        "dimensionInputErrors": "{dimension} input error details",
        "evaluationStatusDetails": "Evaluation status details",
        "limitDetails": "Limit details",
        "matrixCapacityReached": "Maximum of {count} matrices reached.",
        "vectorCapacityReached": "Maximum of {count} vectors reached.",
        "diagnosticInvalidExpression": "Enter a valid expression with a result from -100 to 100.",
        "diagnosticExpressionResourceLimit": "This expression is too large or creates too much data. Use a smaller collection or a simpler equivalent.",
        "diagnosticEvaluationTimeout": "This expression took too long to evaluate. Try a less expensive equivalent.",
        "diagnosticEvaluationUnavailable": "Expression evaluation is temporarily unavailable. Your last valid result is still shown.",
        "expressionOperators": "Operators",
        "expressionOperatorsDescription": "These are common examples; implicit multiplication is supported.",
        "expressionFunctions": "Functions",
        "expressionFunctionsDescription": "These are common examples; trigonometric arguments use radians.",
        "expressionExamples": "Examples",
        "gestures": "Canvas & equation gestures",
        "reorder": "Reorder",
        "reorderDescription": "Drag matrices or vector columns. Use each matrix slider to set its step duration.",
        "reorderInstructions": "To reorder this item, press Alt plus Left Arrow or Alt plus Right Arrow.",
        "reorderedItem": "Moved {label} to position {position} of {total}.",
        "navigate": "Navigate",
        "navigateDescription": "Drag to pan in 2D. In 3D, drag to orbit and right-drag to pan. Scroll or pinch to zoom.",
        "projectLinks": "Project links",
        "equals": "equals",
        "computedVectors": "Computed transformed vectors",
        "staleResults": "Showing the last valid result because the equation contains invalid input.",
        "evaluatingExpressions": "Evaluating the updated expressions. The last valid result is shown for now.",
        "inputMatricesAndVectors": "Input matrices and vectors",
        "matrices": "Matrices",
        "addMatrix": "Add matrix",
        "addVector": "Add vector",
        "matrixPresets": "Matrix presets",
        "vectorPresets": "Vector presets",
        "inverseCurrentTransform": "Inverse of current transform",
        "inversePresetRequiresValidMatrices": "Fix the invalid matrix input to compute the inverse transform.",
        "inverseTransformUnavailable": "The current transform is not invertible.",
        "inversePresetCapacityReached": "The equation does not have room for another matrix.",
        "reflectionAxisPreset": "Reflect across {axis}-axis",
        "reflectionPlanePreset": "Reflect across {plane}-plane",
        "rotationPreset": "Rotate {angle}°{axis}",
        "aroundAxis": "around {axis}",
        "allEigenbasis": "Approximate eigenbasis",
        "oneEigenvector": "Approximate eigenvector",
        "eigenPresetsRequireValidMatrices": "Fix the invalid matrix input to compute eigenvectors.",
        "eigenvectorUnavailable": "The numerical solver could not establish a valid real eigenvector.",
        "eigenbasisUnavailable": "The numerical solver could not establish a complete real eigenbasis.",
        "eigenvectorPresetCapacityReached": "The equation does not have room for another vector.",
        "eigenbasisPresetCapacityReached": "The equation does not have room for all eigenbasis vectors.",
        "matrix": "Matrix {label}",
        "deleteMatrix": "Delete {label}",
        "matrixValues": "{label} matrix values",
        "matrixEntries": "{label} entries",
        "matrixEntry": "{label} row {row} column {column}",
        "matrixDuration": "{label} duration",
        "deleteVector": "Delete {label}",
        "vectorComponent": "{label} component {component}",
        "inputVectorMatrix": "Input vector matrix",
        "inputVectorColumns": "Input vector columns",
        "transformedVector": "{label} transformed",
        "transformedVectorComponent": "{label} transformed component {component}",
        "transformedVectorsUpdated": "Transformed vectors updated.",
        "transformedVectorMatrix": "Transformed vector matrix",
        "transformedVectorColumns": "Transformed vector columns"
      }
    },
    "zh-Hant": {
      "label": "繁體中文",
      "path": "zh-hant/",
      "languageTag": "zh-Hant",
      "languageAliases": ["zh-TW", "zh-HK"],
      "page": {
        "applicationName": "Mattriz",
        "title": "Mattriz — 互動式線性變換矩陣視覺化工具",
        "description": "透過可編輯的矩陣、向量與動態座標格線，互動探索二維及三維線性變換。",
        "openGraphSiteName": "Mattriz",
        "openGraphLocale": "zh_TW"
      },
      "manifest": {
        "path": "manifest.zh-Hant.webmanifest",
        "name": "Mattriz",
        "short_name": "Mattriz",
        "description": "透過可編輯的矩陣、向量與動態座標格線，互動探索二維及三維線性變換。"
      },
      "messages": {
        "language": "語言",
        "transformationViewport": "線性變換視窗",
        "animatedCoordinateSpace": "動態座標空間",
        "viewportPreparing": "正在準備視覺化功能…",
        "viewportUnavailableTitle": "視覺化功能無法使用",
        "viewportUnavailableDescription": "WebGL 無法啟動。您仍可編輯方程式並使用下方控制項。",
        "retryViewport": "重試視覺化功能",
        "dimension": "維度",
        "appControls": "應用程式控制",
        "resetView": "重設視角",
        "resetWorkspace": "重設工作區",
        "resetWorkspaceTitle": "要重設工作區嗎？",
        "resetWorkspaceDescription": "這會清除所有矩陣、向量、視角與設定，並恢復預設工作區。",
        "confirmResetWorkspace": "全部重設",
        "cancel": "取消",
        "share": "儲存並分享",
        "sharing": "正在分享…",
        "shareTimedOut": "分享逾時",
        "shareRequiresValidWorkspace": "請先修正無效輸入再分享。",
        "copied": "已儲存並複製",
        "shareCopiedTitle": "工作區已儲存，連結已複製",
        "shareCopiedDescription": "您的工作區已儲存於此連結。將連結貼到訊息中即可分享。",
        "shareManualTitle": "工作區已儲存，請複製連結",
        "shareManualDescription": "無法自動複製。請選取並複製下方已儲存的工作區連結。",
        "shareLink": "已儲存的工作區連結",
        "copyFailed": "複製失敗",
        "shareTooLarge": "連結過長",
        "invalidShareTitle": "分享的工作區無效",
        "invalidShareDescription": "此分享工作區無效、不安全，或使用不支援的版本。已載入預設工作區。",
        "about": "關於",
        "controls": "控制項",
        "animation": "動畫",
        "animationControls": "動畫控制",
        "applyTransform": "套用變換",
        "pauseAnimation": "暫停動畫",
        "resumeAnimation": "繼續動畫",
        "apply": "套用",
        "pause": "暫停",
        "resume": "繼續",
        "reset": "重設",
        "resetTransform": "重設變換",
        "method": "方式",
        "animationMethod": "動畫方式",
        "steps": "逐步變換",
        "composed": "合成變換",
        "basis": "基底",
        "grid": "格線",
        "transformationEquation": "變換方程式",
        "quickReference": "快速指引",
        "aboutMattriz": "關於 Mattriz",
        "close": "關閉",
        "intro": "建立矩陣與向量，觀察每個二維或三維線性變換的過程。",
        "mattrizControls": "Mattriz 控制項",
        "control": "控制項",
        "whatItDoes": "功能",
        "switchDimensions": "切換工作區的 ℝ² 與 ℝ³ 模式。",
        "restoreCamera": "將目前維度的相機視角恢復至預設狀態。",
        "applyDescription": "讓矩陣對向量與格線的變換產生動畫。",
        "pauseDescription": "暫停動畫，或從同一進度繼續播放。",
        "resetDescription": "將變換恢復為單位矩陣。",
        "methodDescription": "逐一播放矩陣變換，或一次播放合成後的變換。",
        "basisDescription": "顯示或隱藏變換後的基底向量。",
        "gridDescription": "顯示或隱藏變換後的座標格線。",
        "addDescription": "在方程式中加入可編輯的矩陣或向量。",
        "expressions": "運算式",
        "expressionsDescription": "元素可輸入結果介於 -100 與 100 之間的實數數學運算式。",
        "inputErrors": "輸入錯誤詳細資訊",
        "dimensionInputErrors": "{dimension} 輸入錯誤詳細資訊",
        "evaluationStatusDetails": "計算狀態詳細資訊",
        "limitDetails": "限制詳細資訊",
        "matrixCapacityReached": "矩陣數量已達上限 {count} 個。",
        "vectorCapacityReached": "向量數量已達上限 {count} 個。",
        "diagnosticInvalidExpression": "請輸入結果介於 -100 與 100 之間的有效運算式。",
        "diagnosticExpressionResourceLimit": "此運算式過大或建立了過多資料。請使用較小的集合或較精簡的等效運算式。",
        "diagnosticEvaluationTimeout": "此運算式的計算時間過長。請嘗試計算成本較低的等效運算式。",
        "diagnosticEvaluationUnavailable": "目前暫時無法計算運算式，將繼續顯示上次的有效結果。",
        "expressionOperators": "運算子",
        "expressionOperatorsDescription": "以上是常見範例；支援顯式乘法與隱式乘法。",
        "expressionFunctions": "函數",
        "expressionFunctionsDescription": "以上是常見範例；三角函數的引數使用弧度。",
        "expressionExamples": "範例",
        "gestures": "畫布與方程式操作",
        "reorder": "重新排序",
        "reorderDescription": "拖曳矩陣或行向量以重新排序。每個矩陣的滑桿可設定該步驟的時間。",
        "reorderInstructions": "若要重新排序此項目，請按 Alt 加向左鍵或 Alt 加向右鍵。",
        "reorderedItem": "已將 {label} 移至第 {position} 個位置，共 {total} 個。",
        "navigate": "瀏覽",
        "navigateDescription": "在 2D 中拖曳以平移；在 3D 中拖曳以環繞，按右鍵拖曳以平移。捲動或以雙指縮放。",
        "projectLinks": "專案連結",
        "equals": "等於",
        "computedVectors": "變換後的向量",
        "staleResults": "方程式含有無效輸入，目前顯示的是最後一次有效結果。",
        "evaluatingExpressions": "正在計算更新後的運算式，目前暫時顯示上次的有效結果。",
        "inputMatricesAndVectors": "輸入矩陣與向量",
        "matrices": "矩陣",
        "addMatrix": "新增矩陣",
        "addVector": "新增向量",
        "matrixPresets": "矩陣預設",
        "vectorPresets": "向量預設",
        "inverseCurrentTransform": "目前變換的反矩陣",
        "inversePresetRequiresValidMatrices": "請先修正矩陣中的無效輸入，才能計算反矩陣。",
        "inverseTransformUnavailable": "目前的變換不可逆。",
        "inversePresetCapacityReached": "方程式沒有空間容納另一個矩陣。",
        "reflectionAxisPreset": "沿 {axis} 軸鏡射",
        "reflectionPlanePreset": "沿 {plane} 平面鏡射",
        "rotationPreset": "{axis}旋轉 {angle}°",
        "aroundAxis": "繞 {axis} 軸",
        "allEigenbasis": "近似特徵基底",
        "oneEigenvector": "近似特徵向量",
        "eigenPresetsRequireValidMatrices": "請先修正矩陣中的無效輸入，才能計算特徵向量。",
        "eigenvectorUnavailable": "數值求解器無法確認有效的實數特徵向量。",
        "eigenbasisUnavailable": "數值求解器無法確認完整的實數特徵基底。",
        "eigenvectorPresetCapacityReached": "方程式沒有空間容納另一個向量。",
        "eigenbasisPresetCapacityReached": "方程式沒有空間容納所有特徵基底向量。",
        "matrix": "{label} 矩陣",
        "deleteMatrix": "刪除 {label}",
        "matrixValues": "{label} 矩陣值",
        "matrixEntries": "{label} 元素",
        "matrixEntry": "{label} 第 {row} 列第 {column} 行",
        "matrixDuration": "{label} 動畫時間",
        "deleteVector": "刪除 {label}",
        "vectorComponent": "{label} 的第 {component} 個分量",
        "inputVectorMatrix": "輸入向量矩陣",
        "inputVectorColumns": "輸入行向量",
        "transformedVector": "變換後的 {label}",
        "transformedVectorComponent": "變換後的 {label} 第 {component} 個分量",
        "transformedVectorsUpdated": "變換後的向量已更新。",
        "transformedVectorMatrix": "變換後的向量矩陣",
        "transformedVectorColumns": "變換後的行向量"
      }
    }
  }
}
